import { useEffect } from "react";
import {
    StreamVideo,
    StreamVideoClient,
} from "@stream-io/video-react-sdk";
import { useSelector } from "react-redux";
import apiInstance from "../config/api";


const apiKey = process.env.REACT_APP_STREAM_API_KEY;
const client = new StreamVideoClient({ apiKey });



export const StreamClientProvider = ({ children }) => {
    const { userData, profilePhotoUrl } = useSelector(state => state.user)

    useEffect(() => {
        if (!userData.userId) {
            return
        }

        const fetchUserToken = async () => {
            try {
                const response = await apiInstance.get("/api/calls")
                const data = response.data

                if (data.status === 'success') {

                    await client.disconnectUser()

                    await client.connectUser({
                        id: userData.userId,
                        name: `${userData.firstName} ${userData.lastName}`,
                        image: profilePhotoUrl
                    }, data.token)
                }
            }
            catch (error) {
                console.log('unable to connect user to stream; ', error.message)
            }
        }

        fetchUserToken()

        return async () => {
            await client.disconnectUser()
        }
    }, [userData, profilePhotoUrl])

    return (
        <StreamVideo client={client}>
            {children}
        </StreamVideo>
    )
}